import { Project } from "projen/lib";
import { Vitest } from "../../vitest/vitest-component";
import { AgentRuleBundle } from "../agent-config-options";
import { AGENT_RULE_SCOPE } from "../types";
import { findProjectsWithComponent, hasComponent } from "./utils";

/**
 * Vitest bundle — auto-detected when the Vitest component is present.
 */
export const vitestBundle: AgentRuleBundle = {
  name: "vitest",
  description: "Vitest testing conventions, patterns, and file scoping",
  appliesWhen: (project: Project) => hasComponent(project, Vitest),
  findApplicableProjects: (project: Project) =>
    findProjectsWithComponent(project, Vitest),
  rules: [
    {
      name: "vitest-testing",
      description: "Vitest testing conventions and patterns",
      scope: AGENT_RULE_SCOPE.FILE_PATTERN,
      filePatterns: ["**/*.test.ts", "**/*.spec.ts"],
      content: [
        "# Vitest Testing Patterns",
        "",
        "## Mandatory Requirements",
        "",
        "- **Tests MUST be created or updated whenever code functionality is added or changed**",
        "- This applies to all code changes, including:",
        "  - New features and functionality",
        "  - Bug fixes",
        "  - Refactoring that changes behavior",
        "  - API changes",
        "  - Configuration changes that affect functionality",
        "- Tests should be written or updated as part of the same change that modifies the code",
        "",
        "## Test Structure",
        "",
        "- Use **Vitest** as the test runner",
        "- Test files: `.spec.ts` or `.test.ts` (co-located with source)",
        "- Use descriptive test names: `describe('ClassName', () => { it('should do something specific', () => {}) })`",
        "- Prefer snapshot tests for complex object structures",
        "- Mock external dependencies appropriately",
        "",
        "## Test Organization",
        "",
        "- Co-locate test files with source files",
        "- Test files can use dev dependencies (ESLint rule override)",
        "- Import from `vitest`: `import { describe, expect, it } from 'vitest'`",
        "",
        "## Example Test Structure",
        "",
        "```typescript",
        "import { describe, expect, it } from 'vitest';",
        "import { MyClass } from './my-class';",
        "",
        "describe('MyClass', () => {",
        "  it('should do something specific', () => {",
        "    // Test implementation",
        "  });",
        "});",
        "```",
      ].join("\n"),
      tags: ["testing"],
    },
  ],
  claudePermissions: {
    allow: ["Bash(npx vitest:*)"],
  },
};
